import { forwardRef } from 'react';
import { toPrice } from '../../../utils/parsers';

export type TooltipProperties = {
    currentValue: number;
    goal: number;
    inYears: number;
    deposit: number;
};

export const ForecastChartTooltip = forwardRef<HTMLDivElement, TooltipProperties>(
    ({ currentValue, goal, inYears, deposit }, ref) => {
        const reachesGoal = currentValue > goal;
        const reachesDeposit = currentValue > deposit;
        return (
            <div id="chartjs-tooltip" className="absolute transition opacity-0 hover:opacity-100" ref={ref} hidden>
                <div
                    className={`bg-white border-2 ${
                        reachesGoal ? 'border-bnd-green' : reachesDeposit ? 'border-bnd-orange' : 'border-bnd-red'
                    } rounded-lg p-4 flex flex-col text-sm`}
                >
                    <span className="text-base font-semibold">Over {inYears} jaar</span>
                    <div className="grid grid-cols-2 grid-rows-3 gap-x-4 gap-y-1 mt-2">
                        <div>Resultaat:</div>
                        <div className="text-right">
                            {toPrice(currentValue || 0, { onlyFullEuros: true, withCurrencySymbol: true })}
                        </div>
                        <div>Doel:</div>
                        <div className="text-right">{toPrice(goal, { onlyFullEuros: true })}</div>
                        <div>Inleg:</div>
                        <div className="text-right">
                            {toPrice(deposit, { onlyFullEuros: true, withCurrencySymbol: true })}
                        </div>
                    </div>
                </div>
            </div>
        );
    },
);
